import { css, cx } from 'linaria';
const bubbleStyles = "b1bq2cra";
const floatingBubble = "f1806ge7";
export const InlineNotification = props => <span {...props} aria-hidden="true" className={bubbleStyles} />;
export const FloatingNotification = props => <span {...props} aria-hidden="true" className={cx(bubbleStyles, floatingBubble)} />;

require("./notification.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./notification.js");